__turbopack_context__.v({
  "root": "PlasmicTableTbody-module__zvg-Ka__root",
  "tableTd__iIuUs": "PlasmicTableTbody-module__zvg-Ka__tableTd__iIuUs",
  "tableTd__nJh7": "PlasmicTableTbody-module__zvg-Ka__tableTd__nJh7",
  "tableTd__oGcT": "PlasmicTableTbody-module__zvg-Ka__tableTd__oGcT",
  "tableTd__qK5A1": "PlasmicTableTbody-module__zvg-Ka__tableTd__qK5A1",
  "tableTr__osIMv": "PlasmicTableTbody-module__zvg-Ka__tableTr__osIMv",
  "text___1HHCk": "PlasmicTableTbody-module__zvg-Ka__text___1HHCk",
  "text__eQ1Dc": "PlasmicTableTbody-module__zvg-Ka__text__eQ1Dc",
  "text__gbcKr": "PlasmicTableTbody-module__zvg-Ka__text__gbcKr",
  "text__hdVT": "PlasmicTableTbody-module__zvg-Ka__text__hdVT",
});
